import { Html, useProgress } from "@react-three/drei";
import LoaderSpinner from "../LoaderSpinner/Main";

const ThreeDimensionModelLoader = () => {
  const { progress } = useProgress();

  return (
    <Html center className="three-dimension-model-loader">
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px'
      }}>
        <LoaderSpinner />
        <div style={{
          color: '#000',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          {Math.round(progress)}% loaded
        </div>
      </div>
    </Html>
  );
};

export default ThreeDimensionModelLoader;
